import PortalShell from '../layouts/PortalShell'
import { mountSurface } from '../lib/inertia'
import { initTheme } from '../lib/theme'

initTheme()

mountSurface({
  pages: import.meta.glob('../pages/portal/**/*.tsx'),
  layout: (page) => <PortalShell>{page}</PortalShell>,
})
